import React from 'react';
import Button from 'view/components/buttons/Button';
import AudioPlayer from 'view/components/common/AudioPlayer';

import 'view/style/student/components/assignment/bookCompletedFooter.css';
interface BookCompletedFooterProps {
  onViewQuestions?: () => void;
  submissionAudio?: string | null;
  teacherView?: boolean;
}

const BookCompletedFooter: React.FC<BookCompletedFooterProps> = ({
  submissionAudio,
  teacherView,
  onViewQuestions,
}) => {
  return (
    <div className="reading-footer">
      <div className="book-completed-text"></div>
      <div className="book-completed-text">
        {teacherView ? (
          <AudioPlayer audioUrl={submissionAudio} />
        ) : (
          <h2>You're Done</h2>
        )}
      </div>
      <div className="book-completed-text">
        {onViewQuestions && (
          <Button
            type="option"
            onClick={onViewQuestions}
            text="Questions"
            label="Questions"
          />
        )}
      </div>
    </div>
  );
};

export default BookCompletedFooter;
